module.exports = __webpack_public_path__ + "static/media/map_1_overview_2.4476d92a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/widgets/map/assets/map_1_overview_2.svg
// module id = 746
// module chunks = 0